// extracted by mini-css-extract-plugin
export default {"header":"Header_header__HDlLT","logotype":"Header_logotype__nHSUY","buttons":"Header_buttons__Yas1+","settings":"Header_settings__1Sdve"};